import {ILanguageCodes} from '@core/models';


export const EXCEL_EXPORT_LIMITS = {
  // NUMBER_LIMIT: trong bản cũ không thấy dùng nữa
  // NUMBER_LIMIT: 2000, // Cho phép download tối đa 2k bản ghi
  FOR_CSV: 20000, // Cho phép download tối đa 20k bản ghi
  FOR_CSV2: 10000, // Cho phép download tối đa 10k bản ghi
  FOR_CSV3: 5000, // Cho phép download tối đa 5k bản ghi
  FOR_CSV4: 100000, // 100.000 records
  FOR_CSV5: 50000, // 50.000 records
  CSV_ALL_NUMBER_LIMIT: 20000, // Cho phép download tối đa 20k bản ghi
};


/**
 * Const khai báo đường link file excel mẫu "file excel offline, file google sheets..."
 *
 * */
export type ExcelUriFilesExpLinks = Record<ILanguageCodes, string>;

type ExcelUriFilesExample = Record<string, Record<'excel' | 'ggs', {
  name: string,
  links: ExcelUriFilesExpLinks
}>>

export const EXCEL_URI_FILES_EXAMPLE: ExcelUriFilesExample = {
  // [uriConsts.order.MANAGE_IMPORT]: {
  // excel: {
  // name: 'Nhanh.vn_Import_Order.xlsm',
  // links: {
  // 'vi-VN': '/file/Nhanh.vn_Import_Order.xlsm',
  // 'en-US': '/file/Nhanh.vn_Import_Order.xlsm',
  // },
  // },
  // ggs: {
  // name: 'Nhanh.vn_Import_Order',
  // links: {
  // 'vi-VN': 'https://docs.google.com/spreadsheets/d/1qCu0FqcuZ1dct7CvF6AG8BtZDp5NZ9nwlECFzNprWak/edit?gid=0#gid=0',
  // 'en-US': 'https://docs.google.com/spreadsheets/d/1qCu0FqcuZ1dct7CvF6AG8BtZDp5NZ9nwlECFzNprWak/edit?gid=0#gid=0',
  // },
  // },
  // },

};

